import React, { useRef, useEffect } from "react";

const VoiceVisualizer = ({ isRecording, stream }) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);

  useEffect(() => {
    if (!isRecording || !stream) return;

    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const analyser = audioContext.createAnalyser();
    const source = audioContext.createMediaStreamSource(stream);

    source.connect(analyser);
    analyser.fftSize = 512;
    analyser.smoothingTimeConstant = 0.85;

    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    analyserRef.current = analyser;
    dataArrayRef.current = dataArray;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const draw = () => {
      if (!isRecording) return;

      animationRef.current = requestAnimationFrame(draw);

      analyser.getByteFrequencyData(dataArray);

      // Clear with fade effect - dark background
      ctx.fillStyle = "rgba(20, 27, 45, 0.95)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const barWidth = (canvas.width / bufferLength) * 3.5;
      let barHeight;
      let x = 0;

      for (let i = 0; i < bufferLength; i++) {
        barHeight = (dataArray[i] / 255) * canvas.height * 0.7;

        // Modern gradient bars - yellow to orange
        const gradient = ctx.createLinearGradient(
          0,
          canvas.height - barHeight,
          0,
          canvas.height
        );

        // Yellow to orange gradient (hue 50 to 30)
        const hue = 50 - (i / bufferLength) * 20; // Goes from yellow (50) to orange (30)
        gradient.addColorStop(0, `hsla(${hue}, 85%, 60%, 0.8)`);
        gradient.addColorStop(1, `hsla(${hue}, 85%, 55%, 1)`);

        ctx.fillStyle = gradient;
        ctx.fillRect(x, canvas.height - barHeight, barWidth - 2, barHeight);

        x += barWidth;
      }
    };

    draw();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      if (audioContext.state !== "closed") {
        audioContext.close();
      }
    };
  }, [isRecording, stream]);

  return (
    <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-adhd-yellow/10 to-adhd-orange/10 border border-adhd-yellow/20 p-1">
      <canvas
        ref={canvasRef}
        width={600}
        height={100}
        className="w-full h-24 rounded-xl"
      />
    </div>
  );
};

export default VoiceVisualizer;
